import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import RMSquat from '../../scchartcomponent/rmsquatchart';
import RMClean from '../../scchartcomponent/rmcleanchart';
import RMBench from '../../scchartcomponent/rmbenchchart';
import KMRun from'../../scchartcomponent/kmrunchart';
import VerticalJump from '../../scchartcomponent/verticaljumchart';
import PullUp from '../../scchartcomponent/pullupchart';
import Acceleration from '../../scchartcomponent/accelerationchart';
import Endurance from '../../scchartcomponent/endurancechart';

import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import ReportHeader from "Routes/reportTemplate/header";
import ReportFooter from "Routes/reportTemplate/footer";
import ReportBGImage from "Routes/reportTemplate/watermark";

import {  
    scVisualisationDetails
} from 'Actions';

class mainvisual extends React.Component {
    static propTypes = {
        classes: PropTypes.object,
    };
    

    constructor(props) {
      
        super(props);
        this.state = {   
            
            selyear:this.props.data.selyear,
            selassessment:this.props.data.selassessment,
            visualid:this.props.data.visualid, 
            previousLength:0,
            valuelength:0,
        };
       this.selectorRef = React.createRef(null);
    }   

    handleInput(event) {
        const bullet = "\u2022";
        const inputValue = event.target.value;
        const cursorPosition = event.target.selectionStart;
        let lines = inputValue.split('\n');
      
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          if (!line.trim().startsWith(bullet)) {
            lines[i] = `${bullet} ${line.trimLeft()}`;
          }
        }
      
        let newValue = lines.join('\n');
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          if (cursorPosition === 0) {
            const lineIndex = newValue.substr(0, cursorPosition).split('\n').length - 1;
            if (lineIndex > 0) {
              const linesArray = newValue.split('\n');
              linesArray.splice(lineIndex, 1);
              newValue = linesArray.join('\n');
            }
          } else if (newValue[cursorPosition - 1] === bullet && (cursorPosition === newValue.length || newValue[cursorPosition] === '\n')) {
            newValue = newValue.slice(0, cursorPosition - 2) + newValue.slice(cursorPosition);
          }
        }
      
        event.target.value = newValue;
      
        this.setState({
          previousLength: newValue.length,
        });
     }

  render() {

    const { scvisualisationdetails, loading} = this.props;
    let visualdetails=scvisualisationdetails[0].visualimpression;
    let summary_notes='';
    let clubhd_impression='';
    let clubhdshrtgoal1='';
    let clubhdlonggoal1='';
    let clubhd_approach='';
    if(visualdetails.length!=0){
        summary_notes= visualdetails[0].summary_notes; 
        clubhd_impression=visualdetails[0].clubhd_impression; 
        clubhdshrtgoal1=visualdetails[0].clubhdshrtgoal1; 
        clubhdlonggoal1=visualdetails[0].clubhdlonggoal1; 
        clubhd_approach=visualdetails[0].clubhd_approach; 
        
    }
    const styles = {
        mainheading: {
            fontWeight:"bold",
            marginBottom:"30px",
            color:"#000",
            marginTop:"30px"
        },
        subheading: {
            fontWeight:"bold",
            marginTop:"50px", 
            marginBottom:"30px",
            color:"#000",
            position:"relative"
        },
        subheadingsecond: {
            fontWeight:"bold",
            marginTop:"30px", 
            marginBottom:"20px",
            color:"#000",
            position:"relative"
        },
        subheadingfirst: {
            fontWeight:"bold",
            marginTop:"30px", 
            marginBottom:"30px",
            color:"#000",
            position:"relative"
        },
        goals:{
            marginTop:"30px",
            marginBottom:"20px",
            color:"#000"
        },
        goalhead:{
          fontWeight:"bold",
          color:"#000"
        },        
        eachchart:{
           padding:"10px",
           marginBottom:"50px",
           position:"relative"
        },
        texare:{
            color:"#000",
            backgroundColor:"unset"
        },
        table: {
            border: "1px solid black",
            borderColor:"black",
            borderStyle:"solid",
            fontFamily: "Arial",            
            zIndex:"100"
        },
        tabletrtd: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            whiteSpace: "pre-line",
            wordWrap: "break-word",            
            textAlign: "center",
            color:"#000"
        },
        tabletleft: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            whiteSpace: "pre-line",
            wordWrap: "break-word"
            
        },
        tabletrtdhead: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            whiteSpace: "pre-line",
            wordWrap: "break-word",            
            textAlign: "center",
            color:"#000",
            fontWeight:"bold"
        },
        rctcontent:{            
            marginTop:"30px",
            borderRadius: "5px",
            boxShadow: "0 1px 15px 1px rgba(69, 65, 78, 0.08)",
            border: "none",
            transition: "all 0.4s ease-in-out 0s",
            marginBottom: "24px",
            padding:"0px 20px 10px 20px",
            zIndex:"1"
        }
    };


    return (
        <>
        <div className="rwhead">                    
            <input type="button" className="mr-10 mb-10 btn btn-outline-warning float-right" onClick={this.props.onClick} value="Back" />
        </div>
            <RctCollapsibleCard fullBlock > 
                <ReportHeader />
                <div style={styles.rctcontent}>                    
                    <ReportBGImage data={"60%"}/>
                    
                    <div className="rwhead" style={{marginTop:"50px"}}>
                        <h3 className="text-center" style={styles.mainheading}>COMPARATIVE ANALYSIS OF STRENGTH & CONDITIONINGS</h3>
                    </div>
                    {scvisualisationdetails[0].onermsquat.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheadingfirst}>1RM Back Squat</h3>
                     <div style={styles.eachchart}>
                        <RMSquat data={'95%'}/>
                    </div>
                    </>
                    :''}
                    {scvisualisationdetails[0].onermclean.length!=0 ?
                    <>    
                    <h3 className="text-center" style={styles.subheadingfirst}>1RM Clean</h3>
                     <div style={styles.eachchart}>
                        <RMClean data={'95%'}/>
                    </div>
                    </>
                    :''}
                    <ReportFooter />    
                </div>                
            </RctCollapsibleCard>
            <RctCollapsibleCard fullBlock > 
                <ReportHeader />
                <div style={styles.rctcontent}>                     
                    <ReportBGImage data={"60%"}/>
                    <div className="page-break"></div>
                    {scvisualisationdetails[0].onermbench.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheading}>1RM Bench Press</h3>
                     <div style={styles.eachchart}>
                        <RMBench data={'95%'}/>
                    </div>
                    </>
                    :''}
                    
                    {scvisualisationdetails[0].kmrun.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheadingsecond}>Aerobic Fitness Test (2.4km Run)</h3>
                     <div style={styles.eachchart}>
                        <KMRun data={'95%'}/>
                    </div>
                    </>
                    :''}
                    <ReportFooter />    
                </div>                
            </RctCollapsibleCard> 
            <RctCollapsibleCard fullBlock > 
                <ReportHeader />
                <div style={styles.rctcontent}>                     
                    <ReportBGImage data={"60%"}/>
                    <div className="page-break"></div>
                    {scvisualisationdetails[0].verticaljump.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheading}>Lower Body Power Test (Vertical Jump)</h3>
                     <div style={styles.eachchart}>
                        <VerticalJump data={'95%'}/>
                    </div>
                     </>
                    :''}
                    {scvisualisationdetails[0].pullup.length!=0 ?
                    <>                    
                    <h3 className="text-center" style={styles.subheadingsecond}>Upper Body Strength Test (Pull Up)</h3>
                     <div style={styles.eachchart}>
                        <PullUp data={'95%'}/>
                    </div>   
                    </>
                    :''}                 
                    <ReportFooter />    
                </div>                
            </RctCollapsibleCard>   
            <RctCollapsibleCard fullBlock > 
                <ReportHeader /> 
                <div style={styles.rctcontent}>                    
                    <ReportBGImage data={"60%"}/>
                    <div className="page-break"></div>
                    {scvisualisationdetails[0].acceleration.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheading}>Acceleration Speed Test (20m Sprint Speed)</h3>
                    <div style={styles.eachchart}>
                        <Acceleration data={'95%'}/>
                    </div>
                    </>
                    :''}
                    
                    {scvisualisationdetails[0].endurance.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheadingsecond}>Core Endurance Test (Plank)</h3>
                    <div style={styles.eachchart}>
                        <Endurance data={'95%'}/>
                    </div>
                    </>
                    :''}
                    <ReportFooter />    
                </div>                
            </RctCollapsibleCard> 
            <RctCollapsibleCard fullBlock > 
                <ReportHeader /> 
                <div style={styles.rctcontent}>                    
                    <ReportBGImage data={"45%"}/>
                    <div className="page-break"></div> 
                    <h3 className="text-center" style={styles.subheading}>SUMMARY NOTES </h3>
                    <div style={styles.eachchart}>
                        <div className="row rwhead">
                            <textarea rows="4" type="text" style={styles.texare} name="summary_notes" id="summary_notes" defaultValue={summary_notes} className="form-control" disabled></textarea>
                        </div>
                    </div>
             
                    <h3 className="text-center" style={styles.subheading}>PERFORMANCE ENHANCEMENT</h3>
                    <div style={styles.eachchart}>
                            <table className="table align-items-center table-flush" style={styles.table}>
                                    <tbody>
                                        <tr>                                          
                                            <td rowSpan="2" style={styles.tabletrtdhead}>IMPRESSION  </td>
                                            <td colSpan="2" style={styles.tabletrtdhead}>GOAL  </td>
                                            <td rowSpan="2"style={styles.tabletrtdhead}>APPROACH </td>
                                        </tr>
                                        <tr>
                                            <td style={styles.tabletrtdhead}>Short Term Goals</td>
                                            <td style={styles.tabletrtdhead}>Long Term Goals</td>
                                        </tr> 
                                        <tr>  
                                            <td style={styles.tabletleft}><textarea style={{border:"0px", backgroundColor: "unset"}} rows="10" type="text" defaultValue={clubhd_impression} name="clubhd_impression" id="clubhd_impression" disabled></textarea></td>
                                            <td style={styles.tabletleft}><textarea style={{border:"0px", backgroundColor: "unset"}} rows="10" type="text" defaultValue={clubhdshrtgoal1} name="clubhdshrtgoal1" id="clubhdshrtgoal1" disabled></textarea></td>
                                            <td style={styles.tabletleft}><textarea style={{border:"0px", backgroundColor: "unset"}} rows="10" type="text" defaultValue={clubhdlonggoal1} name="clubhdlonggoal1" id="clubhdlonggoal1"  disabled></textarea></td>
                                            <td style={styles.tabletleft}><textarea style={{border:"0px", backgroundColor: "unset"}} rows="10" type="text" defaultValue={clubhd_approach} name="clubhd_approach" id="clubhd_approach" disabled></textarea></td>                                                   
                                        </tr>                           
                                    </tbody>
                                </table>   
                    </div>
                   
                    <ReportFooter />    
                </div>                
            </RctCollapsibleCard>   
            <div className="rwhead">                    
                <input type="button" className="mr-10 mb-10 btn btn-outline-warning" onClick={this.props.onClick} value="Back" />
            </div>
      </>
    );
  }
}

const mapStateToProps = ({ scvisualisation }) => {
  const { scvisualisationdetails, loading } = scvisualisation;
return { scvisualisationdetails, loading };
}

export default connect(mapStateToProps, {
    scVisualisationDetails
})(mainvisual); 